import {logCardClick} from '@braze/web-sdk';
import {Component, OnInit, Input, AfterViewInit, Inject, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {Banner} from '../../../../../data/networking/models/cms/responses/banner-res';
import {LazyLoadImageService} from '../../../services/lazy-load-image/lazy-load-image.service';
import {GoogleTagService} from '../../../../../data/networking/services/shared/google-tag/google-tag.service';

@Component({
  selector: 'app-banner-element',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit, AfterViewInit {
  @Input() banner: Banner;
  @Input() customClass;
  @Input() lazyLoaded = false;
  isBrowser;
  constructor(private lazyService: LazyLoadImageService,
              private gtmService: GoogleTagService,
              private router: Router,
              @Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
    this.lazyLoaded = this.lazyLoaded && this.isBrowser;
  }

  redirect() {
    this.clickTracking();

    const bannerValid = this.banner?.redirectUrl !== '' &&
    this.banner?.redirectUrl !== undefined ||
    this.banner?.redirectURL !== '' &&
    this.banner?.redirectURL !== undefined;

    if (bannerValid) {
      this.gtmService.onClickPromo(this.banner, this.router);
    }
  }

  clickTracking(){
    if(this.banner['type'] && this.banner['type'].U === 'ab-image-only'){
      logCardClick(this.banner['type'], true);
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.isBrowser && this.lazyLoaded) {
      const options = {
        wrapperSelector: '.banner-wrapper',
      };
      this.lazyService.lazyLoad(options);
    }
  }
}
